export const ORGANIZATIONS_LOADED = "organizations/loaded"
export const ORGANIZATION_UPDATED = "organizations/updated"